import { render } from "./FormulairesStep2.vue?vue&type=template&id=99241d74&scoped=true"
import script from "./FormulairesStep2.vue?vue&type=script&lang=js"
export * from "./FormulairesStep2.vue?vue&type=script&lang=js"

import "./FormulairesStep2.vue?vue&type=style&index=0&id=99241d74&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99241d74"]])

export default __exports__